import * as vd from "virtual-dom";
export class AxisscaleBarDOMRenderer {
    constructor(container) {
        this._container = container;
        this._minThresholdWidth = 320;
        this._maxThresholdWidth = 1480;
        this._minThresholdHeight = 240;
        this._maxThresholdHeight = 820;
    }
    render(configuration, containerWidth, component, navigator) {
        if (configuration.visible === false) {
            return vd.h("div.infra3dsdk-axisscalebar-container-hidden", {}, []);
        }
        return vd.h("div.infra3dsdk-axisscalebar-container", {
            style: {
                height: "47px",
            },
        }, []);
    }
    getContainerWidth(size, configuration) {
        const minWidth = configuration.minWidth;
        let maxWidth = configuration.maxWidth;
        if (maxWidth < minWidth) {
            maxWidth = minWidth;
        }
        const relativeWidth = (size.width - this._minThresholdWidth) / (this._maxThresholdWidth - this._minThresholdWidth);
        const relativeHeight = (size.height - this._minThresholdHeight) / (this._maxThresholdHeight - this._minThresholdHeight);
        const coeff = Math.max(0, Math.min(1, Math.min(relativeWidth, relativeHeight)));
        return minWidth + coeff * (maxWidth - minWidth);
    }
}
//# sourceMappingURL=AxisscaleBarDOMRenderer.js.map